var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.9994 5.26398e-09C11.3426 4.37896e-10 10 1.34315 10 3V9C10 10.6569 11.3431 12 13 12H19C20.6569 12 22 10.6569 22 9V3C22 1.34315 20.6591 3.7286e-08 19.0023 2.93242e-08C17.262 2.09617e-08 15.0209 1.11521e-08 12.9994 5.26398e-09Z",
    fill: "#1F8E8E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.00781,
    y1: 6,
    x2: 30.0078,
    y2: 6,
    stroke: "#1F8E8E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosIcon);
export default __webpack_public_path__ + "static/media/mos-icon.7c3ec4e3045990d64382c2d021930cdd.svg";
export { ForwardRef as ReactComponent };